import React from "react";

const RADIUS = 10;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const CircularProgress = ({
  progress = 0,
  size = 28,
  strokeWidth = 3,
  trackColor = "rgba(255,255,255,0.3)",
  progressColor = "#ffffff",
  showPercent = true,
  loading = false,
  icon,
  style = {},
}) => {
  const offset = CIRCUMFERENCE * (1 - progress / 100);

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        flexShrink: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {icon && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: loading ? 0 : 1,
            transform: loading ? "scale(0.5)" : "scale(1)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          {icon}
        </div>
      )}
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        style={{
          position: "absolute",
          display: "block",
          opacity: loading ? 1 : 0,
          transform: loading ? "scale(1)" : "scale(0.5)",
          transition: "opacity 0.6s ease, transform 0.6s ease",
        }}
      >
        <circle
          cx="12"
          cy="12"
          r={RADIUS}
          fill="none"
          stroke={trackColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx="12"
          cy="12"
          r={RADIUS}
          fill="none"
          stroke={progressColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          transform="rotate(-90 12 12)"
          style={{ transition: "stroke-dashoffset 0.3s ease" }}
        />
        {showPercent && (
          <text
            x="12"
            y="12"
            textAnchor="middle"
            dominantBaseline="central"
            fill={progressColor}
            fontSize="7"
            fontWeight="600"
            fontFamily="Poppins, sans-serif"
          >
            {Math.round(progress)}
          </text>
        )}
      </svg>
    </div>
  );
};

export { CircularProgress };
